import tw from 'tailwind-styled-components'


export const NavMain = tw.main`
relative 
`
export const NavContainer = tw.nav`
flex 
w-full
gap-6
px-8
pb-6
`
export const NavItem = tw.span`
cursor-pointer
truncate
text-sm
text-darkGray
transition-colors
hover:brightness-90
`

export const NumberStyle = tw.span`
ml-2
text-sm
font-bold
`
export const NavLine = tw.div`
h-1
w-full  
mt-[11px]
absolute
z-20
`
export const BorderLine = tw.div`
h-px 
w-full 
-mt-3
z-0
bg-borderLine
absolute
`